// @ts-nocheck
import React, { createContext, useContext, useMemo, useState } from "react";

const PostContext = createContext();

const PostProvider = ({ children }) => {
	const [postTypeId, setPostTypeId] = useState(null);
	const [postToCreate, setPostToCreate] = useState(null);
	const [propsPageHead, setPropsPageHead] = useState(null);

	const value = useMemo(
		() => ({
			postTypeId,
			setPostTypeId,
			postToCreate,
			setPostToCreate,
			propsPageHead,
			setPropsPageHead,
		}),
		[postTypeId, postToCreate, propsPageHead]
	);

	return (
		<PostContext.Provider value={value}>
			{children}
		</PostContext.Provider>
	);
};

export function usePostContext() {
	return useContext(PostContext);
}

export { PostContext, PostProvider };
